import classes from './Spinner.module.css';

const Spinner = (props) => {
  return <div className={classes.spinner}></div>;
};

export default Spinner;
